
        var result = require("!!../../../../node_modules/css-loader/index.js!./eventaction.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/settings/settings-eventaction/eventaction.component.css
// module id = 2418
// module chunks = 1